import React from 'react';
import styles from './BaixarApp.module.css';
import TituloComponent from '../components/Titulo/TituloComponent';
import { DownloadAppButton } from '../components/DownloadAppButton/DownloadAppButton';
import { FaGlobe, FaCalendarCheck, FaChartLine, FaBell, FaShieldAlt } from 'react-icons/fa';

const BaixarApp = () => {
  const appFeatures = [
    {
      icon: <FaCalendarCheck />,
      title: 'Frequência em Tempo Real',
      desc: 'Acompanhe as faltas, presenças e horários do seu filho instantaneamente.',
    },
    {
      icon: <FaChartLine />,
      title: 'Boletim & Notas',
      desc: 'Consulte notas de avaliações e desempenho escolar de forma simplificada.',
    },
    {
      icon: <FaBell />,
      title: 'Avisos & Notificações',
      desc: 'Receba lembretes de tarefas, eventos e recados importantes da coordenação.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Download Seguro',
      desc: 'Hospedado via Google Firebase com verificações de integridade automáticas.',
    },
  ];

  return (
    <>
      <TituloComponent name="📲 Aplicativo Família 360" />

      <div className={styles.container}>
        <div className={styles.mainWrapper}>
          {/* Top Hero Card */}
          <div className={styles.card}>
            <div className={styles.cardHeader}>
              <div className={styles.appIconWrapper}>
                <span className={styles.appIcon}>📱</span>
              </div>
              <div className={styles.badgeList}>
                <span className={styles.tagBadge}>Plataforma Oficial</span>
                <span className={styles.tagBadgeAndroid}>Android APK</span>
              </div>
            </div>

            <h1 className={styles.title}>App Família 360</h1>
            <p className={styles.subtitle}>
              Acompanhe a vida escolar do seu filho na palma da sua mão ou pelo seu computador.
            </p>

            <div className={styles.actionButtons}>
              <DownloadAppButton showVersionDetails={false} />

              <a
                href="https://web.educacaoalternativa360.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.webBtn}
              >
                <FaGlobe className={styles.btnIcon} />
                <span>Acessar Portal Web (Navegador)</span>
              </a>
            </div>
          </div>

          {/* App Features Section */}
          <div className={styles.featuresSection}>
            <h2 className={styles.featuresTitle}>Recursos do Aplicativo</h2>
            <div className={styles.featuresGrid}>
              {appFeatures.map((feat, index) => (
                <div key={index} className={styles.featureCard}>
                  <div className={styles.featureIcon}>{feat.icon}</div>
                  <div className={styles.featureContent}>
                    <h3>{feat.title}</h3>
                    <p>{feat.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BaixarApp;

